import { render, staticRenderFns } from "./NoRealQueryPage.vue?vue&type=template&id=1feaea69&"
import script from "./NoRealQueryPage.vue?vue&type=script&lang=js&"
export * from "./NoRealQueryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports